var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlPluvialGlobalFathom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    viewBox: "0 0 24 24",
    width: "100%",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.141 6 3.04 3.245V7.968c0-.474.506-.71 1.52-.71.944 0 1.463.206 1.555.618l.013.092V11H11v9.644c-1.073-.444-2.246-.826-3.851-.826-2.559 0-4.275.35-5.149 1.052v-2.817C2.913 17.35 4.608 17 7.083 17c.242 0 .473.009.695.026l-.003-1.095h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.106-.106L13.14 6ZM4.5 8S6 9.612 6 10.567C6 11.358 5.328 12 4.5 12S3 11.358 3 10.567C3 9.612 4.5 8 4.5 8Zm4-4S10 5.612 10 6.567C10 7.36 9.328 8 8.5 8S7 7.359 7 6.567C7 5.612 8.5 4 8.5 4Zm-5-2S5 3.612 5 4.567C5 5.36 4.328 6 3.5 6S2 5.359 2 4.567C2 3.612 3.5 2 3.5 2Zm12.993 13.813v.894h1.633v.71h-1.633v1.566h-.817v-3.897h2.877v.726h-2.06ZM22 22V12H12v10h10Zm-9-9h8v8h-8v-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlPluvialGlobalFathom);
export default __webpack_public_path__ + "static/media/fl_pluvial_global_fathom.6f9acc4983541d626a0d67da9fb51a78.svg";
export { ForwardRef as ReactComponent };